import type { ComponentProps, JSX } from "react"

export type CollapsibleSidebarActiveDotProps = ComponentProps<"span">

export const CollapsibleSidebarActiveDot = (
  props: CollapsibleSidebarActiveDotProps,
): JSX.Element => {
  const { ...rest } = props

  return (
    <span
      aria-hidden="true"
      className="sidebar-link-dot"
      {...rest}
    />
  )
}
